$(document).ready(function () {

    var menuToggles = $('.js-top-menu-toggle');
    menuToggles.on('click', function () {
        if ($(this).is('.collapsed')) {
            menuToggles.not('.collapsed').click();
        }
    });
});